module.exports = __webpack_public_path__ + "static/media/DSC_6303.67807848.jpg";